import classNames from 'classnames';
import React, { FC } from 'react';
import ReactModal from 'react-modal';
import styles from './modal_scrollable_container.module.scss';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  shouldCloseOnOverlayClick?: boolean;
  className?: string;
  overlayClassName?: string;
  shouldFocusAfterRender?: boolean;
};

export const ModalScrollableContainer: FC<Props> = ({
  isOpen,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  className = '',
  overlayClassName = '',
  children,
  shouldFocusAfterRender = true,
}) => {
  const customProps = {
    closeTimeoutMS: 150,
    className: classNames(className, 'react-modal', styles.container),
    overlayClassName: {
      base: classNames(
        overlayClassName,
        'react-modal__overlay',
        styles.overlay,
      ),
      afterOpen: styles.open,
      beforeClose: styles.close,
    },
    isOpen,
    ariaHideApp: false,
    shouldCloseOnOverlayClick,
    onRequestClose,
    bodyOpenClassName: styles.body,
    shouldFocusAfterRender,
  };

  return <ReactModal {...customProps}>{children}</ReactModal>;
};
